import { render } from "./MfittMyTicketRefund.vue?vue&type=template&id=0a986cda"
import script from "./MfittMyTicketRefund.vue?vue&type=script&lang=js"
export * from "./MfittMyTicketRefund.vue?vue&type=script&lang=js"
script.render = render

export default script